<carm-home-page-view class="lang-{{locale}}">   </carm-home-page-view>
